import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useMetaPortal() {
  const route = useRoute();

  const clearFullPageUrl = computed(() => {
    if (typeof window !== 'undefined') {
      return window.location.href.split('?')[0];
    }

    return route.fullPath.split('?')[0];
  });

  return {
    clearFullPageUrl,
  };
}
